import { FetchClientDomain } from './FetchClient/domain';

/**
 * Namespaced so we don't pollute the global intellisense namespace with a billion generically named constants
 */
export namespace FetchServiceDomain {
    export type PopulatedNonPrimitiveValue = Record<string, unknown> | unknown[];
    export type PrimitiveValue = string | number | boolean;
    export enum SupportedMethod {
        GET = 'GET',
        POST = 'POST',
        DELETE = 'DELETE',
        PUT = 'PUT',
        PATCH = 'PATCH',
    }

    export enum SupportedHeader {
        CONTENT_TYPE = 'content-type',
        CALLER_ID = 'x-caller-id',
        AUTHORIZATION = 'authorization',
    }

    export enum HTTPStatus {
        OK = 200,
        BAD_REQUEST = 400,
        UNAUTHORIZED = 401,
        FORBIDDEN = 403,
        NOT_FOUND = 404,
        METHOD_NOT_ALLOWED = 405,
        UNPROCESSABLE_ENTITY = 422,
        INTERNAL_SERVER_ERROR = 500,
    }

    export enum ResponseType {
        NETWORK_ERROR = 'NetworkError',
        RESOLVED = 'Resolved',
    }

    export enum SupportedContentType {
        TEXT = 'text/plain',
        JSON = 'application/json',
        FORM_DATA = 'multipart/form-data',
        URL_FORM_ENCODED = 'application/x-www-form-urlencoded',
    }

    export type SuccessfulResponse<TResponseType = Record<string, unknown>> = {
        type: typeof ResponseType.RESOLVED;
        data: TResponseType;
        statusCode: number;
    };
    export type APIActionParams<TBody = unknown> = {
        accessToken?: string;
        action: string;
        input?: FetchClientDomain.TimeoutableFetchConfig['body'];
        timeout?: number;
        useDotNotation?: boolean;
        headers?: Record<string, string>;
        body?: TBody;
        queryParams?: Record<string, unknown>;
    };
    export type InternalAPIActionParams<TBody = unknown> = APIActionParams<TBody> & { method: SupportedMethod };
    export type NetworkErrorResponse = {
        type: typeof ResponseType.NETWORK_ERROR;
        statusCode?: 0;
    };
    export type APIPromiseProvider<TResponseType = Record<string, unknown>, TBody = unknown> = (
        givenparams: APIActionParams<TBody>
    ) => Promise<SuccessfulResponse<TResponseType> | NetworkErrorResponse>;

    export interface CallableServiceRESTClient extends Record<SupportedMethod, APIPromiseProvider> {
        baseURL: string;
    }
}
